<div class="wrapper">
  <p class="title-admin">
    {{data.name}}
    <i class="bi bi-pencil-square ml-2" (click)="editNameObject(data)"></i>
  </p>

  <div class="wrapper__body">
    <ng-container *ngIf="!loading">
      <!-- Lựa chọn config hình ảnh trước/sau -->
      <div class="mb-4 mt-2">
        <div class="mb-3" style="line-height: normal">{{'cau_hinh_anh_truoc_sau' | translate}}</div>
        <nz-select [(ngModel)]="selectedImageToConfig">
          <nz-option nzValue="image__before" nzLabel="{{'anh_truoc' | translate }}"></nz-option>
          <nz-option nzValue="image__after" nzLabel="{{'anh_sau' | translate }}"></nz-option>
        </nz-select>
      </div>

      <div style="width: 50%">
        <app-image-upload-option-config 
          [objectChoosing]="data" 
          [setups]="data.setups"
          [staticdata]="data.staticdata" 
          [device]="imageDeviceWidthMax" 
          [imageFieldToConfig]="selectedImageToConfig"
          >
        </app-image-upload-option-config>
      </div>
    
    
      <!-- input này để upload từ thiết bị -->
      <input
        type="file"
        (change)="onUpload($event)"
        id="upload"
        style="display: none"
      />

      <div class="wrapper__content">
        <!-- Ảnh dùng riêng cho từng thiết bị -->
        <ng-container  *ngFor="let device of devices">
          <div *ngIf="data.setups.upload_image.display == 'individual' && device.display " class="wrapper__content--image">
            <!-- header title -->
            <div class="wrapper__content--image__dimension" >
              <!-- icon của thiết bị -->
              <span nz-icon [nzType]="device.icon" nzTheme="outline" data-toggle="tooltip" [title]="'tablet'" nz-tooltip nzTooltipPlacement="bottom"
                [ngStyle]="{
                  transform: device.value.includes('landscape') ? 'rotate(90deg)' : 'rotate(0deg)',
                  scale: '1.2'
                }"
                nzTooltipTitle="{{ device.label | translate}}">
              </span>
              <!-- kích thước ảnh cho thiết bị (width x height) -->
              <strong style="font-size: 16px">{{device.label | translate}}:</strong>  
              ({{device.width}} x {{device.height}})
            </div>
            <!-- ảnh -->
            <div style="position: relative; overflow: auto;min-height: 106px;">
              <div style="position: relative; width: fit-content">
                <!-- hình ảnh hiển thị -->
                <img [id]="device.value + '_' + data._id"
                  style="border: 1px solid black; max-width: 'unset'"
                  [src]="data.staticdata[this.selectedImageToConfig][device.value + '_img']"
                  width="{{device.width}}"
                  height="{{device.height}}" />
                <!-- icon xóa ảnh -->
                <div role="button" class="_icon_trash d-flex align-items-center justify-content-center align-self-center"
                  (click)="deleteImage(device.value)" 
                  nz-tooltip nzTooltipTitle="{{'xoa_anh' | translate}}">
                  <span>X</span>
                </div>
                <!-- icon nhập url ảnh -->
                <div *ngIf="data.setups.upload_image.source == 'url'"
                  role="button" class="_icon_connect d-flex align-items-center justify-content-center align-self-center _icon_connect_active"
                  nz-popover
                  nzPopoverTitle="{{'duong_dan_anh' | translate}}"
                  nzPopoverTrigger="click"
                  [nzPopoverContent]="contentTemplate">
                  <span nz-icon nzType="disconnect" nzTheme="outline"></span>
                </div>
                <!-- icon chọn ảnh từ thiết bị, thư viện -->
                <div *ngIf="data.setups.upload_image.source != 'url'"
                  (click)="handleChangeImage(device.value)"
                  role="button" class="_icon_connect d-flex align-items-center justify-content-center align-self-center _icon_connect_active">
                  <i nz-icon nzType="upload" nzTheme="outline" *ngIf="data.setups.upload_image.source == 'device'"></i>
                  <i nz-icon nzType="picture" nzTheme="outline" *ngIf="data.setups.upload_image.source == 'library'"></i>
                  <i nz-icon nzType="cloud-upload" nzTheme="outline" *ngIf="data.setups.upload_image.source == 'free_img'"></i>
                </div>
                <!-- Button chuyển ảnh lên server -->
                <!-- Nếu ảnh chứa id_subproject thì đã là ảnh trên server rồi nên sẽ disable -->
                <button  class="_icon_upload d-flex align-items-center justify-content-center align-self-center _icon_connect_active"
                  *ngIf="!data.staticdata[this.selectedImageToConfig][device.value + '_img'].includes(id_subproject) " 
                  nz-button nzType="primary" (click)="isShowConfirmPopup = true">
                  {{'chuyen_anh_len_server'  | translate}}
                </button>
              </div>
              <!-- template nhập url ảnh -->
              <ng-template #contentTemplate>
                <input style="width: 260px;" class="input mr-1" type="text" 
                  [(ngModel)]="data.staticdata[this.selectedImageToConfig][device.value + '_img']"
                  placeholder="{{'nhap_duong_dan_lien_ket' | translate}}" />
                <span (click)="changeUrl()"
                  role="button" class="text-success">
                  {{'ap_dung' | translate}}
                </span>
              </ng-template>
            </div>
          </div>
        </ng-container>
  
        <!-- Ảnh dùng chung cho tất cả thiết bị -->
        <ng-container *ngIf="data.setups.upload_image.display == 'shared'">
          <div class="wrapper__content--image">
            <!-- kích thước ảnh cho thiết bị (width x height) -->
            <div class="wrapper__content--image__dimension">
              {{widthImageMax}} x {{heightImageMax}}
            </div>
            <div style="position: relative; overflow: auto;min-height: 106px;">
              <div style="position: relative; width: fit-content">
                <!-- hình ảnh hiển thị -->
                <img [id]="'_' + data._id"
                  style="border: 1px solid black; max-width: 'unset'"
                  [src]="data.staticdata[this.selectedImageToConfig][imageDeviceWidthMax + '_img']"
                  (click)="handleChangeImage(imageDeviceWidthMax)"
                  width="{{widthImageMax}}"
                  height="{{heightImageMax}}" />
                <div role="button" class="_icon_trash d-flex align-items-center justify-content-center align-self-center"
                  (click)="deleteImage(imageDeviceWidthMax)" nz-tooltip nzTooltipTitle="{{'xoa_anh' | translate}}">
                <span>X</span>
                </div>
                <div role="button"
                  class="_icon_connect d-flex align-items-center justify-content-center align-self-center _icon_connect_active"
                  *ngIf="data.setups.upload_image.source == 'url'"
                  nz-popover
                  nzPopoverTitle="{{'duong_dan_anh' | translate}}"
                  nzPopoverTrigger="click"
                  [nzPopoverContent]="contentTemplate">
                  <span nz-icon nzType="disconnect" nzTheme="outline"></span>
                </div>
                <div role="button"
                  class="_icon_connect d-flex align-items-center justify-content-center align-self-center _icon_connect_active"
                  *ngIf="data.setups.upload_image.source != 'url'"
                  (click)="handleChangeImage(imageDeviceWidthMax)">
                  <i  nz-icon nzType="upload" nzTheme="outline" *ngIf="data.setups.upload_image.source == 'device'"></i>
                  <i nz-icon nzType="picture" nzTheme="outline" *ngIf="data.setups.upload_image.source == 'library'"></i>
                  <i nz-icon nzType="cloud-upload" nzTheme="outline" *ngIf="data.setups.upload_image.source == 'free_img'"></i>
                </div>
                <!-- Button chuyển ảnh lên server -->
                <!-- Nếu ảnh chứa id_subproject thì đã là ảnh trên server rồi nên sẽ disable -->
                <button class="_icon_upload d-flex align-items-center justify-content-center align-self-center _icon_connect_active" 
                  *ngIf="!data.staticdata[this.selectedImageToConfig][imageDeviceWidthMax + '_img'].includes(id_subproject)" 
                  nz-button nzType="primary" (click)="isShowConfirmPopup = true">
                  {{'chuyen_anh_len_server'  | translate}}
                </button>
              </div>
              <!-- template nhập url ảnh -->
              <ng-template #contentTemplate>
                <input style="width: 260px;" class="input mr-1" type="text" 
                  [(ngModel)]="data.staticdata[this.selectedImageToConfig][imageDeviceWidthMax + '_img']"
                  placeholder="{{'nhap_duong_dan_lien_ket' | translate}}" />
                <span (click)="changeUrl()"
                  role="button" class="text-success">
                  {{'ap_dung' | translate}}
                </span>
              </ng-template>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <!-- Loading -->
    <div *ngIf="loading" style="display: flex; align-items: center; justify-content: center; width: 100%; height: 300px">
      <nz-spin nzSimple></nz-spin> 
    </div>
  </div>
</div>



<!-- MODAL CHUYỂN ẢNH LÊN SERVER -->
<nz-modal nzTitle="{{ 'chuyen_anh_len_server' | translate}}" [(nzVisible)]="isShowConfirmPopup" [nzContent]="modalContent"
  (nzOnCancel)="handleCancelConfirm()" (nzOnOk)="handleOkConfirm()" [nzFooter]="modalFooter">
  <ng-template #modalContent>
    <!-- select chọn nen_anh_tai_len -->
    <p>{{'nen_anh_tai_len' | translate}}</p>
    <nz-select [(ngModel)]="data.setups.upload_image.compress_type" (ngModelChange)="updateObject({setups: data.setups})"
      nzPlaceHolder="{{'nen_anh_tai_len' | translate}}" nzAllowClear>
      <nz-option [nzValue]="'no-compress'" nzLabel="{{'khong_nen_anh_sau_khi_tai_len' | translate}}"></nz-option>
      <nz-option [nzValue]="'compress-screen'" nzLabel="{{'nen_anh_theo_ti_le_man_hinh_hien_thi' | translate}}"></nz-option>
      <nz-option [nzValue]="'compress-frame'" nzLabel="{{'nen_anh_theo_ti_le_khung_hien_thi_anh' | translate}}"></nz-option>
      <nz-option [nzValue]="'custom'" nzLabel="{{'nen_anh_theo_kich_thuoc_tu_chon' | translate}}"></nz-option>
    </nz-select>
    <!-- chieu_rong -->
    <mat-form-field *ngIf="data.setups.upload_image.compress_type == 'custom'" class="mt-4 mr-4">
      <mat-label>{{'chieu_rong' | translate}}</mat-label>
      <input matInput placeholder="{{'chieu_rong' | translate}}" [(ngModel)]="compressWidth">
    </mat-form-field>
    <!-- chieu_cao -->
    <mat-form-field *ngIf="data.setups.upload_image.compress_type == 'custom'">
      <mat-label>{{'chieu_cao' | translate}}</mat-label>
      <input matInput placeholder="{{'chieu_cao' | translate}}" [(ngModel)]="compressHeight">
    </mat-form-field>
  </ng-template>
  <!-- Button Dong y / Khong -->
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancelConfirm()">{{'khong' | translate}}</button>
    <button nz-button nzType="primary" (click)="handleOkConfirm()" >{{'dong_y' | translate}}</button>
  </ng-template>
</nz-modal>

